import Reflux from 'reflux';

const VersionNumberActions = Reflux.createActions({
  show: {},
  hide: {},
});

export default VersionNumberActions;
